import { Box, Typography } from '@mui/material'
import * as React from 'react'
import { useSelector } from 'react-redux'
import { getScenarioGanttRows } from '../../store/EventById/selectors'
import { MachineCategory, Scenario } from '../../types'

type Props = {
	scenario: Scenario
}

// 機器タイプ別の色（ガントバー）。muted で light/dark 両対応。
const colorByCategory: Partial<Record<MachineCategory, string>> = {
	heating: '#e08a2b',
	denji: '#1f9e8c',
}

// シナリオ一覧カード用の薄型ガント。時間割り当てされた機器(heating/denji)の
// 24時間 ON/OFF を機器ごとに帯で俯瞰する。
function ScenarioGanttMini({ scenario }: Props) {
	const rows = useSelector((s) => getScenarioGanttRows(s, scenario))

	if (rows.length === 0) return null

	return (
		<Box sx={{ mt: 0.75, display: 'grid', gap: '3px' }}>
			{rows.map((row) => (
				<Box
					key={row.controlId}
					sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
				>
					<Typography
						variant="caption"
						sx={{
							width: '5.5rem',
							flexShrink: 0,
							color: 'text.secondary',
							whiteSpace: 'nowrap',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
						}}
						title={row.label}
					>
						{row.label}
					</Typography>
					<Box
						sx={{
							flex: 1,
							display: 'grid',
							gridTemplateColumns: 'repeat(24, 1fr)',
							gap: '1px',
						}}
					>
						{row.hours.map((on, h) => (
							<Box
								key={h}
								title={`${h}時 ${on ? 'ON' : 'OFF'}`}
								sx={{
									height: 9,
									borderRadius: '2px',
									bgcolor: on
										? colorByCategory[row.category] ?? 'success.main'
										: 'action.disabledBackground',
									opacity: on ? 0.95 : 0.5,
								}}
							/>
						))}
					</Box>
				</Box>
			))}
		</Box>
	)
}

export default ScenarioGanttMini
